import { SubmittedFormModel } from "../../../services/api/types/forms/models/SubmittedFormModel";
import { Button, ButtonText } from "ui/gluestack/button";
import React, { useRef } from "react";
import { ModifySubmissionModal } from "../modals/ModifySubmissionModal";
import { View } from "ui/atoms/view";

interface Props {
  entry: SubmittedFormModel;
}

export function AssessmentEntryModifySubmissionAction({ entry }: Props) {
  const ref = useRef<React.ComponentRef<typeof ModifySubmissionModal>>(null);
  const handleShowModal = () => {
    ref.current?.show(entry);
  };
  return (
    <View>
      <Button action="secondary" onPress={handleShowModal}>
        <ButtonText>Modify submission</ButtonText>
      </Button>
      <ModifySubmissionModal ref={ref} />
    </View>
  );
}
